




































import Vue from 'vue'
import { UiLanguageItem, UiLanguageList } from '@/types'
import LogoutUserError from '@/model/error/LogoutUserError'
import { LOG_USER_OUT, SELECT_UI_LANGUAGE } from '@/store/action-types'
import { CurrentUser } from '@/model/CurrentUser'
import { getCookieByName } from '@/services/get-cookie-by-name'

interface ComponentData {
  showError: boolean
  errorMessage: string | undefined
  browserId: string
}

export default Vue.extend({
  name: 'CurrentUserProfileHeader',

  props: {
    employeePhoto: String
  },

  computed: {
    currentUser (): CurrentUser {
      return this.$store.state.currentUser
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedUiLanguage (): UiLanguageItem {
      return this.$store.state.selectedUiLanguage
    }
  },

  methods: {
    onLanguageItemChange (languageCode: string): void {
      const selectedLanguageItem = this.uiLanguageList
        .filter((item: UiLanguageItem) => item.code === languageCode)
        .pop()

      if (selectedLanguageItem) {
        this.$store.dispatch(SELECT_UI_LANGUAGE, selectedLanguageItem)
        this.$router.push('/')
      }
    },

    async onLogoutClick (): Promise<void> {
      try {
        await this.$store.dispatch(LOG_USER_OUT, true)
          .catch((e: LogoutUserError) => {
            this.errorMessage = e.message
            this.showError = true
          })
        this.$router.push('/login')
      }catch (e) {
        this.errorMessage = e.message
        this.showError = true
      }
    }
  },

  data (): ComponentData {
    return {
      showError: false,
      errorMessage: undefined,
      browserId: ''
    }
  },

  created (): void {
    this.browserId = getCookieByName('AssignedBrowserName')
  }
})
